import React from "react";
import { get } from "lodash";
import { Field } from "formik";
import { FieldInputNumber } from "../../../components";
import { yesNoOptions, returnOnlyIfBoolean } from "../../../utils";
import {
  FieldButtonGroup,
  FieldDropSide,
  SearchableList,
} from "../../../components";
import {
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  requiredWithErrorCode,
} from "../../../utils";

export const OtherInformation = (props) => {
  const { values, fields, setFieldValue, isEdit, isSave, handleChange } = props;
  return (
    <div>
      <div className="plan-sub-heading mt-0"></div>{" "}
      <div className="plan-sub-heading mt-0">Reallocation</div>
      <Field
        isRequired
        name={`enrollmentOtherInformation.${fields.allowReallocation}`}
        label="Allow Reallocation"
        size="sm"
        options={yesNoOptions}
        selectedValue={returnOnlyIfBoolean(
          get(
            values,
            `enrollmentOtherInformation.${fields.allowReallocation}`,
            null
          )
        )}
        onChange={(value) => {
          setFieldValue(
            `enrollmentOtherInformation.${fields.allowReallocation}`,
            value
          );
          if (!value) {
            setFieldValue(
              `enrollmentOtherInformation.${fields.reAllocationPeriod}`,
              null
            );
            setFieldValue(
              `enrollmentOtherInformation.${fields.numberOfReallocationAllowed}`,
              null
            );
          }
        }}
        disabled={isEdit && !isSave}
        value={get(values.enrollmentOtherInformation, fields.allowReallocation)}
        component={FieldButtonGroup}
      />
      {get(values.enrollmentOtherInformation, fields.allowReallocation, "") ==
      true ? (
        <>
          <Field
            isRequired
            label="Reallocation Period"
            name={`enrollmentOtherInformation.${fields.reAllocationPeriod}`}
            value={get(
              values.enrollmentOtherInformation,
              fields.reAllocationPeriod
            )}
            disabled={isEdit && !isSave}
            options={toOptionValuesFromMapper(
              OPTIONS_DATA_MAPPER.REALLOCATION_PERIOD
            )}
            popupContent={
              <SearchableList
                label="Reallocation Period"
                isNotTypeAhead
                options={toOptionValuesFromMapper(
                  OPTIONS_DATA_MAPPER.REALLOCATION_PERIOD
                )}
                onSelect={(value) =>
                  setFieldValue(
                    `enrollmentOtherInformation.${fields.reAllocationPeriod}`,
                    value
                  )
                }
                selectedValue={get(
                  values,
                  `enrollmentOtherInformation.${fields.reAllocationPeriod}`,
                  null
                )}
                isRadio
              />
            }
            // validate={(val) => requiredWithErrorCode(val, "PL546")}
            component={FieldDropSide}
          />

          <Field
            isRequired
            name={`enrollmentOtherInformation.${fields.numberOfReallocationAllowed}`}
            label={"Number of Reallocations Allowed"}
            type="number"
            autoComplete="off"
            value={get(
              values.enrollmentOtherInformation,
              fields.numberOfReallocationAllowed
            )}
            onChange={handleChange}
            component={FieldInputNumber}
            // validate={(val) => requiredWithErrorCode(val, "PL547")}
            min={1}
            max={120}
            disabled={isEdit && !isSave}
          />
        </>
      ) : (
        ""
      )}
      <p className="plan-sub-heading">Enrollment Invite</p>
      <Field
        isRequired
        label="Send Enrollment Invite"
        name={`enrollmentOtherInformation.${fields.sendEnrollmentInvite}`}
        value={get(
          values.enrollmentOtherInformation,
          fields.sendEnrollmentInvite
        )}
        disabled={isEdit && !isSave}
        options={toOptionValuesFromMapper(
          OPTIONS_DATA_MAPPER.ENROLLMENT_INVITE
        )}
        popupContent={
          <SearchableList
            isNotTypeAhead
            options={toOptionValuesFromMapper(
              OPTIONS_DATA_MAPPER.ENROLLMENT_INVITE
            )}
            onSelect={(value) =>
              setFieldValue(
                `enrollmentOtherInformation.${fields.sendEnrollmentInvite}`,
                value
              )
            }
            selectedValue={get(
              values,
              `enrollmentOtherInformation.${fields.sendEnrollmentInvite}`,
              null
            )}
            isRadio
          />
        }
        // validate={(val) => requiredWithErrorCode(val, "PL548")}
        component={FieldDropSide}
      />
      {get(get(values, "enrollmentOtherInformation"), "sendEnrollmentInvite") ==
      2 ? (
        <>
          <Field
            isRequired
            name={`enrollmentOtherInformation.${fields.numberOfDaysBeforeEntryDate}`}
            label={"Number Of Days Before Entry Date"}
            type="number"
            autoComplete="off"
            value={get(
              values.enrollmentOtherInformation,
              fields.numberOfDaysBeforeEntryDate
            )}
            onChange={handleChange}
            component={FieldInputNumber}
            min={1}
            max={120}
            // validate={(val) => requiredWithErrorCode(val, "PL549")}
            disabled={isEdit && !isSave}
          />
        </>
      ) : (
        ""
      )}
    </div>
  );
};
